
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M438.6 102.6L345.52 9.34C339.6 3.371 331.5 0 322.1 0H192.5c-35.3 0-63.9 28.65-63.9 64v288c0 35.35 28.6 64 63.88 64h191.6c35.22 0 63.92-28.7 63.92-64V125.3c0-8.5-3.4-16.7-9.4-22.7zM336.2 22.62L425.4 112h-81.22c-4.398 0-7.985-3.594-7.985-8V22.62zM432 352c0 26.47-21.49 48-47.91 48H192.5c-26.42 0-47.91-21.53-47.91-48V64c0-26.47 21.49-48 47.91-48h127.8v88c0 13.22 10.76 24 23.95 24h87.83v224zm-121.2 96a7.915 7.915 0 00-7.837 6.805C299.6 478.1 279.6 496 255.5 496H63.88c-26.46 0-47.91-21.49-47.91-48V160c0-26.51 21.45-48 47.91-48h23.95c4.412 0 7.985-3.582 7.985-8s-3.565-8-7.985-8H63.88C28.6 96 0 124.7 0 160v288c0 35.34 28.69 64 63.97 64h191.5c32.2 0 58.83-23.87 63.24-54.91.69-4.79-3.11-9.09-7.91-9.09z"}})])
          )
        }
      }
    